var _excluded = ["event"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }

function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

import { addTelemetryDebug, createHttpRequest, jsonStringify, objectEntries } from '@datadog/browser-core';
export function createFormDataTransport(configuration, lifeCycle, createEncoder, streamId) {
  var reportError = function reportError(error) {
    lifeCycle.notify(14
    /* LifeCycleEventType.RAW_ERROR_COLLECTED */
    , {
      error: error
    }); // monitor-until: forever, to keep an eye on the errors reported to customers

    addTelemetryDebug('Error reported to customer', {
      'error.message': error.message
    });
  };

  var httpRequest = createHttpRequest([configuration.profilingEndpointBuilder], configuration.batchBytesLimit, reportError);
  var encoder = createEncoder(streamId);
  return {
    send: function send(_ref) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var event, attachments, formData, serializedEvent, bytesCount, _iterator, _step, _step$value, key, value, serializedValue, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event = _ref.event, attachments = _objectWithoutProperties(_ref, _excluded);
                formData = new FormData();
                serializedEvent = jsonStringify(event);

                if (serializedEvent) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Failed to serialize event');

              case 5:
                formData.append('event', new Blob([serializedEvent], {
                  type: 'application/json'
                }), 'event.json');
                bytesCount = serializedEvent.length;
                _iterator = _createForOfIteratorHelper(objectEntries(attachments));
                _context.prev = 8;

                _iterator.s();

              case 10:
                if ((_step = _iterator.n()).done) {
                  _context.next = 22;
                  break;
                }

                _step$value = _slicedToArray(_step.value, 2), key = _step$value[0], value = _step$value[1];
                serializedValue = jsonStringify(value);

                if (serializedValue) {
                  _context.next = 15;
                  break;
                }

                throw new Error('Failed to serialize attachment');

              case 15:
                _context.next = 17;
                return encode(encoder, serializedValue);

              case 17:
                result = _context.sent;
                bytesCount += result.outputBytesCount;
                formData.append(key, new Blob([result.output]), key);

              case 20:
                _context.next = 10;
                break;

              case 22:
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](8);

                _iterator.e(_context.t0);

              case 27:
                _context.prev = 27;

                _iterator.f();

                return _context.finish(27);

              case 30:
                httpRequest.send({
                  data: formData,
                  bytesCount: bytesCount
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[8, 24, 27, 30]]);
      }))();
    }
  };
}

function encode(encoder, data) {
  return new Promise(function (resolve) {
    encoder.write(data);
    encoder.finish(function (encoderResult) {
      resolve(encoderResult);
    });
  });
}